<template>
  <div
    class="promo section"
    :style="sectionStyle"
  >
    <div class="container">
      <div class="left-column">
        <div
          v-if="title"
          class="title q-mb-md q-mx-auto"
          :style="titleStyle"
        >
          {{ title }}
        </div>
        <div
          v-if="description"
          :style="descriptionStyle"
          class="description q-mb-lg q-mx-auto"
          v-html="$options.filters.pureHtml(description)"
        />
        <CTAButton v-bind="cta"/>
      </div>
      <div>
        <q-img
          v-if="photoUrl"
          :src="photoUrl"
          :width="`${photoWidth}px`"
          class="block q-mx-auto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CTAButton from './CTAButton';
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';
import photoMixin from './mixins/photoMixin';
import popupMixin from './mixins/popupMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'PromoSection',
  components: { CTAButton },
  mixins: [
    backgroundMixin,
    titleMixin,
    descriptionMixin,
    popupMixin,
    photoMixin,
  ],
  props: {
    cta: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.promo {
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 50px 0;
}
</style>
